import { defineFurniture } from './types.js';
import type { FurnitureDef } from './types.js';

/**
 * Newsroom TVs (category 'fun', interaction { type: 'news', channel }).
 * Owned by the news feature; see news.ts.
 */
export const MEDIA_FURNITURE: Record<string, FurnitureDef> = {
  ...defineFurniture('fun', {
    news_tv_updates: {
      label: 'News TV: Game Updates',
      description: "A studio screen reading out what's new. Click to watch.",
      price: 900,
      solid: true,
      height: 1.6,
      interaction: { type: 'news', channel: 'updates' },
    },
    news_tv_stats: {
      label: 'News TV: Live Stats',
      description: 'The world by the numbers, live. Click to watch.',
      price: 900,
      solid: true,
      height: 1.6,
      interaction: { type: 'news', channel: 'stats' },
    },
    news_tv_events: {
      label: 'News TV: Game Events',
      description: 'Wins, prizes and new rooms as they happen. Click to watch.',
      price: 900,
      solid: true,
      height: 1.6,
      interaction: { type: 'news', channel: 'events' },
    },
  }),
};
